export const PARTNER_TYPE = {
  default: '0',
  singleBalance: '1'
};
